import { render } from "./ModalWrapper.vue?vue&type=template&id=2ccd3feb"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__